import { useGetContactsCustomerCountQuery } from 'services';
import { FindAllContactCustomersDto } from 'types';

export function useContactCustomersCount(queryParams: FindAllContactCustomersDto) {
  const { data: contactRes, isLoading } = useGetContactsCustomerCountQuery(queryParams, {
    skip: !queryParams,
    refetchOnMountOrArgChange: true
  });

  return {
    count: contactRes?.data ?? 0,
    isLoading
  };
}
